export default __webpack_public_path__ + "static/media/note3.ffb87670.jpeg";